import { useCallback, useEffect, useRef } from 'react';

export const useDebounce = <Callback extends (...args: never[]) => void>(
    callback: Callback,
    delay: number = 0,
) => {
    const timer = useRef<NodeJS.Timeout>(undefined);
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        return () => {
            if (timer.current) clearTimeout(timer.current);
        };
    }, []);

    const debouncedCallback = useCallback(
        (...args: Parameters<Callback>) => {
            if (timer.current) clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                callbackRef.current(...args);
            }, delay);
        },
        [delay],
    );

    return debouncedCallback;
};
